import { render } from "./PatientBanner.vue?vue&type=template&id=204b3e3a&scoped=true"
import script from "./PatientBanner.vue?vue&type=script&lang=js"
export * from "./PatientBanner.vue?vue&type=script&lang=js"

import "./PatientBanner.vue?vue&type=style&index=0&id=204b3e3a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b3e3a"]])

export default __exports__